import React from "react";
import { Button, Toggle, Tooltip } from '@opendate-app/setlist';

import {
  PUBLISH_MENU_ITEM,
  CUSTOMIZE_MENU_ITEM
} from "../constants/confirmTicketingConstants";

import {
  SpotifyLogo,
  BandsintownLogo,
  GoogleLogo,
  YouTubeLogo,
  ShazamLogo,
  AppleMapsLogo
} from '../../../shared/Logos';

const Promotions = ({
  csrfToken,
  team,
  confirm,
  confirmChanged,
  autoSaveConfirm,
  performers,
  activeMenuItemChanged
}) => {
  const isDisabled = (
    performers.length === 0
      || !confirm.is_public
  );

  const handleToggle = (e) => {
    const updated = {
      ...confirm,
      promote_on_bandsintown: e.target.checked
    };

    confirmChanged(updated);
    autoSaveConfirm(csrfToken, team, updated);
  };

  const partners = [
    { name: "Spotify", logo: <SpotifyLogo /> },
    { name: "Bandsintown", logo: <BandsintownLogo /> },
    { name: "Google", logo: <GoogleLogo /> },
    { name: "YouTube", logo: <YouTubeLogo /> },
    { name: "Shazam", logo: <ShazamLogo /> },
    { name: "Apple Maps", logo: <AppleMapsLogo /> }
  ];

  return (
    <div className="pt-3 pb-4 px-4">
      {/* Header with divider - 16px gap */}
      <div className="d-flex flex-column mb-4" style={{gap: "16px"}}>
        <div className="d-flex flex-column" style={{gap: "4px"}}>
          <p className="font-weight-bold m-0" style={{
            fontSize: "16px",
            lineHeight: "24px",
            color: "var(--sl-text-primary)"
          }}>
            Promote Your Event
          </p>
        </div>
        <hr className="m-0 w-100 border-0" style={{
          height: "1px",
          backgroundColor: "var(--sl-border-secondary)"
        }} />
      </div>

      {/* Syndicate section - constrained to 400px width */}
      <div style={{marginBottom: "32px"}}>
        <div className="d-flex" style={{gap: "16px", alignItems: "flex-end"}}>
          <div className="d-flex flex-column" style={{
            gap: "8px",
            maxWidth: "400px",
            width: "100%"
          }}>
            <p className="font-weight-bold m-0" style={{
              fontSize: "16px",
              lineHeight: "24px",
              color: "var(--sl-text-primary)"
            }}>
              Syndicate to Partners
            </p>
            
            <div className="d-flex align-items-center w-100">
              <Tooltip title={isDisabled ? "Only public events with performers can be promoted on these platforms." : null}
                       maxWidth={200}>
                <span className="flex-shrink-0 mr-2">
                  <Toggle id="confirm-promote-on-bandsintown"
                          aria-label="Syndicate to partners"
                          disabled={isDisabled}
                          checked={isDisabled ? false : Boolean(confirm.promote_on_bandsintown)}
                          onChange={handleToggle} />
                </span>
              </Tooltip>
              <p className="m-0 flex-grow-1 small" style={{
                fontWeight: "500",
                color: "var(--sl-text-secondary)",
                lineHeight: "20px"
              }}>
                Send this event to our partners, allowing fans of this artist to discover this event across multiple platforms
              </p>
            </div>
          </div>
          <div className="flex-grow-1"></div>
        </div>
      </div>

      {/* Divider */}
      <hr className="m-0 w-100 border-0 mb-4" style={{
        height: "1px",
        backgroundColor: "var(--sl-border-secondary)"
      }} />

      {/* Partners section */}
      <div className="d-flex flex-column mb-4" style={{gap: "32px"}}>
        <p className="m-0 small" style={{
          fontWeight: "500",
          color: "var(--sl-text-primary)",
          lineHeight: "20px"
        }}>
          Your event will be sent to:
        </p>
        
        <div className="d-flex flex-wrap" style={{gap: "10px"}}>
          {partners.map((partner) => (
            <div 
              key={partner.name} 
              className="d-flex align-items-center rounded p-3"
              style={{
                backgroundColor: "var(--sl-bg-secondary)",
                gap: "10px"
              }}
            >
              <div className="flex-shrink-0" style={{
                width: "32px",
                height: "32px"
              }}>
                {partner.logo}
              </div>
              <p className="m-0 small font-weight-bold" style={{color: "var(--sl-text-primary)"}}>
                {partner.name}
              </p>
            </div>
          ))}
        </div>

        {/* Button */}
        <div className="d-flex justify-content-end w-100">
          <Button variant="primary"
                  onClick={() => {
                    if(team.can_use_structured_checkout){
                      activeMenuItemChanged(CUSTOMIZE_MENU_ITEM);
                    } else {
                      activeMenuItemChanged(PUBLISH_MENU_ITEM);
                    }
                  }}>
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Promotions;
